<template>
  <div>
    <notifications group="foo" classes="paypoint-notification-style" />
    <b-overlay :show="formBusy" rounded="sm" :spinner-small="false">
      <div id="content-container-with-border">
        <div v-if="!this.UIModeForgotPassword">
          <form id="submitLoginForm" @submit="submitLoginForm">
            <h3>Welcome</h3>

            <b-row>
              <b-col>
                <div class="form-group">
                  <label class="form-label"
                    >Site Number/Email
                    <span id="coloured-subnote">*</span>
                  </label>
                  <div class="badged-inputbox">
                    <input
                      id="siteid_email"
                      name="siteid_email"
                      type="text"
                      v-model="loginData.siteid_email"
                      class="form-control form-control-lg"
                      @keyup="onUsernameChange(loginData.siteid_email)"
                      ref="siteid_emailFformField"
                      autocomplete="off"
                    />
                    <transition name="bounce">
                      <Badge
                        v-if="badgeString && badgeString !== ''"
                        class="overlayed-badge"
                        variant="retailer-type-yellow"
                        >{{ badgeString }}&nbsp;<b-spinner
                          v-if="accountLookupInAction"
                          type="grow"
                          variant="secondary"
                        ></b-spinner>
                      </Badge>
                    </transition>
                  </div>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <transition-group tag="div" name="slide-fade">
                  <div
                    v-if="displayAccountChoice"
                    class="form-group"
                    key="container"
                  >
                    <label class="form-label">&nbsp;</label>
                    <DeviceChoice
                      :displayAccountChoice="displayAccountChoice"
                      :clickHandler="clickHandlerCard"
                    />
                  </div>
                </transition-group> </b-col
            ></b-row>
            <transition-group tag="div" name="slide-fade">
              <div
                v-if="loginData.Username != null && !displayAccountChoice"
                class="form-group"
                key="container"
              >
                <label class="form-label" key="label">Username</label>
                <input
                  id="username"
                  name="username"
                  type="text"
                  v-model="loginData.Username"
                  class="form-control form-control-lg"
                  key="Username"
                  autocomplete="off"
                />
              </div>
            </transition-group>

            <transition-group tag="div" name="slide-fade">
              <div
                class="form-group"
                v-if="!displayAccountChoice"
                key="container"
              >
                <label class="form-label">Password</label>
                <input
                  id="password"
                  name="password"
                  type="password"
                  v-model="loginData.Password"
                  class="form-control form-control-lg"
                  autocomplete="off"
                  key="Password"
                />
              </div>
            </transition-group>

            <div v-if="this.loginType == 'agent'" class="paypoint-link">
              <a
                id="agent-forgot-password-cta"
                @click="forgotPasswordClickHandler()"
                ><em>Forgot password?</em></a
              >
            </div>
            <div class="bottom-section" v-if="!displayAccountChoice">
              <div class="form-group form-group-errors"></div>

              <div class="login-button">
                <ButtonNew
                  buttonId="loginButton"
                  variant="search"
                  type="submit"
                  :isBusy="false"
                  :isDisabled="isLoginButtonDisabled()"
                  datacy="submit-login-form-button"
                  :onClick="resetNotifications"
                >
                  {{ loginButtonString }}
                  <template v-slot:icon>
                    <RightArrowIcon
                      :internalColour="
                        isLoginButtonDisabled() ? '#BEBEBE' : '#FFFFFF'
                      "
                  /></template>
                </ButtonNew>
              </div>
            </div>
            <div id="blurb" v-if="!displayAccountChoice">
              <span id="coloured-subnote">*</span
              ><em
                >Email Log in - only applicable for Agents accessing statement
                documents.</em
              >
              <div id="click-to-register">
                If you have been sent a registration letter,
                <a href="/Account/Register"
                  >click here to register to access this site.</a
                >
                <p>
                  <a @click="enablePayPointLiteLoginJourney()">&nbsp;</a>
                </p>
              </div>
            </div>
          </form>
        </div>
        <div v-else-if="this.forceUserToChangePassword">
          <PPConnectForcePasswordReset
            :isDisabledCallback="isForgotPasswordbuttonDisabledPPMini"
            :submitPasswordForgotFormCallback="submitPasswordForgotForm"
            :email="this.loginData.siteid_email"
            :isBusy="forgotPasswordFormBusy"
            :backToLoginPageClickHandler="backToLoginPageClickHandler"
          />
        </div>
        <div v-else>
          <ForgotPasswordContent
            :isDisabledCallback="isForgotPasswordbuttonDisabled"
            :submitPasswordForgotFormCallback="submitPasswordForgotForm"
            :email="this.loginData.siteid_email"
            :isBusy="forgotPasswordFormBusy"
            :backToLoginPageClickHandler="backToLoginPageClickHandler"
          />
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";
import ButtonNew from "Components/ButtonNew";
import Badge from "Components/Badge";
import ForgotPasswordContent from "Components/ForgotPasswordContent";
import RightArrowIcon from "Assets/svg/rightArrow.vue";
import { isValidEmailAddress } from "Assets/Utilities.js";
import { copy } from "Assets/Copy.js";
import DeviceChoice from "./DeviceChoice";
//import PPConnectForcePasswordReset from "./PPConnectForcePasswordReset.vue";

const queryString = require("query-string");

export default {
  name: "DynamicLoginPage",
  components: {
    ButtonNew,
    Badge,
    RightArrowIcon,
    ForgotPasswordContent,
    DeviceChoice,
  },
  data() {
    return {
      accountLookupInAction: false,
      forceUserToChangePassword: false,
      featurePPLiteLoginTurnedOn: false,
      hasPPLite: false,

      isForgotPasswordButtonDisabled: false,
      UIModeForgotPassword: false,
      formBusy: false,
      loginData: {
        siteid_email: "",
        site: null,
        Username: "",
        Password: "",
      },
      loginType: null, // string 'site' or 'agent'  or 'sitePayPointMini'
      badgeString: null,
      loginButtonString: "Log in",
      forgotPasswordFormBusy: false,
      displayAccountChoice: false,
      accountDataCache: {},
    };
  },
  mounted() {
    const uriParams = queryString.parse(location.search);
    let ourReturnURL = "";
    Object.keys(uriParams).forEach(function(key) {
      const lowerKey = key.toLowerCase();
      if (lowerKey === "returnurl") {
        ourReturnURL = uriParams[key];
      }
    });
    this.loginData.ReturnUrl = ourReturnURL;
    this.focusInput();
  },
  methods: {
    enablePayPointLiteLoginJourney() {
      this.displayAccountChoice = true;
      this.badgeString = "";
      this.hasPPLite = true;
    },
    onUsernameChange(siteid_email) {
      this.featurePPLiteLoginTurnedOn && this.resetUIForPPOne();

      if (siteid_email === "" || siteid_email === null) {
        this.badgeString = "";
        this.loginButtonString = "Log in";
      } else if (isValidEmailAddress(siteid_email)) {
        console.log("AGENT");
        this.badgeString = "Agent";
        this.loginButtonString = "Agent Log in";
        this.removeUsernameField();
        this.loginType = "agent";
        // } else if (this.isNumber(siteid_email)) {
      } else if (
        // Has the user entered a PPMini SiteID?  Lets check
        this.is5OrMoreNumbers(siteid_email) &&
        this.featurePPLiteLoginTurnedOn
      ) {
        this.checkIfUserHasAPPLiteAccount();

        this.loginData.site = siteid_email;
      } else if (this.isNumber(siteid_email)) {
        this.badgeString = "";
        this.badgeString = "PayPoint One Site";
        this.addUsernameField();
        this.loginType = "site";
        this.loginButtonString = "Site Log in";
      } else {
        this.badgeString = "";
        this.loginType = null;
        this.loginButtonString = "Log in";
        this.displayAccountChoice = false;
      }
    },
    resetUIForPPOne() {
      this.displayAccountChoice = false;
      this.badgeString = "PayPoint One Site";
      this.loginButtonString = "Log in";
    },
    checkIfUserHasAPPLiteAccount() {
      // console.log("checkIfUserHasAPPLiteAccount");
      this.badgeString = " ";
      this.hasPPLite = false;
      this.accountLookupInAction = true;

      var siteId = parseInt(this.loginData.siteid_email);
      axios
        .get(
          `api/PaypointConnectLogin/HasPaypointConnectAccount?` +
            `siteId=${siteId}`
        )
        .then((response) => {
          this.accountLookupInAction = false;
          console.log(response.data);
          if (response.data.hasPaypointConnectAccount) {
            this.displayAccountChoice = true;
            this.badgeString = "PayPoint Mini Site";
            this.hasPPLite = true;
          } else {
            this.resetUIForPPOne();
          }
        })
        .catch((error) => {
          this.accountLookupInAction = false;
          this.badgeString = "PayPoint One Site";
          this.hasPPLite = false;
          console.log(error);
        });
    },

    focusInput() {
      this.$refs.siteid_emailFformField &&
        this.$refs.siteid_emailFformField.focus();
    },
    forgotPasswordClickHandler() {
      this.UIModeForgotPassword = true;
    },
    backToLoginPageClickHandler() {
      this.UIModeForgotPassword = false;
    },
    isLoginButtonDisabled() {
      if (!this.loginType) {
        return true;
      }
      if (this.loginType == "site" || this.loginType == "sitePayPointMini") {
        if (
          !this.loginData.siteid_email ||
          !this.loginData.Username ||
          !this.loginData.Password
        ) {
          return true;
        }
      }
      if (this.loginType == "agent") {
        if (!this.loginData.siteid_email || !this.loginData.Password) {
          return true;
        }
      }
      return false;
    },
    submitPasswordForgotForm(email) {
      console.log(`submit form ${email}`);
      this.forgotPasswordFormBusy = true;

      axios
        .post("api/SendForgottenAgentPasswordEmail", { emailAddress: email })
        .then((response) => {
          this.$notify({
            group: "foo",
            title: copy.passwordResetemailSentTitle,
            text: "We sent a password reset link to " + email,
            duration: -1,
          });

          this.forgotPasswordFormBusy = false;
          this.UIModeForgotPassword = 0;
          this.loginData.siteid_email = null;
          this.badgeString = null;
        })
        .catch((error) => {
          if (error.response) {
            this.$notify({
              group: "foo",
              title: "Error",
              text: copy.catchAllServerError,
              duration: -1,
            });
          } else {
            this.$notify({
              group: "foo",
              title: "Password Reset - Error",
              text: copy.catchAllServerError,
              duration: -1,
            });
          }
          this.forgotPasswordFormBusy = false;
        });
      return false;
    },
    isForgotPasswordbuttonDisabled(email) {
      if (isValidEmailAddress(email)) {
        return false;
      }
      return true;
    },
    displayNotification(errorMessage) {
      this.$notify({
        group: "foo",
        title: "Error",
        text: errorMessage,
        duration: -1,
      });
    },
    submitLoginForm(e) {
      e.preventDefault();
      var loginUrl = "";
      var loginData = null;

      if (this.loginType === "sitePayPointMini") {
        console.log("Attempting login as PayPoint Mini site");
        loginUrl = "api/PaypointConnectLogin";
        loginData = {
          SiteId: this.loginData.siteid_email,
          Username: this.loginData.Username,
          password: this.loginData.Password,
          returnUrl: this.loginData.ReturnUrl,
        };
      } else if (this.loginType == "site") {
        loginUrl = "api/login";
        loginData = {
          site: this.loginData.siteid_email,
          username: this.loginData.Username,
          password: this.loginData.Password,
          returnUrl: this.loginData.ReturnUrl,
        };
      } else {
        loginUrl = "api/AgentLogin";
        loginData = {
          email: this.loginData.siteid_email,
          password: this.loginData.Password,
          returnUrl: this.loginData.ReturnUrl,
        };
      }
      this.formBusy = true;
      axios
        .post(loginUrl, loginData)
        .then((response) => {
          window.location = response.data.returnUrl;
        })
        .catch((error) => {
          this.formBusy = false;
          if (!error.response) {
            this.displayNotification(copy.catchAllServerError);
            return;
          }
          var responseData = error.response.data;
          if (responseData.errors) {
            responseData.errors.forEach((errorMessage) => {
              this.displayNotification(errorMessage);
            });
            return;
          }
          if (responseData.validationErrors) {
            responseData.validationErrors.forEach((errorMessage) => {
              this.displayNotification(errorMessage);
            });
            return;
          }
          this.displayNotification(copy.catchAllServerError);
        });
    },
    isNumber(str) {
      return /^\d+$/.test(str);
    },
    is5OrMoreNumbers(str) {
      return /^\d\d\d\d\d+$/.test(str);
    },
    resetNotifications() {
      this.$notify({
        group: "foo",
        clean: true,
      });
    },
    removeUsernameField() {
      if (this.loginData.Username != null) {
        Vue.delete(this.loginData, "Username");
      }
    },
    addUsernameField() {
      if (!this.loginData.Username) {
        Vue.set(this.loginData, "Username", "");
      }
    },
    clickHandlerCard(cardClicked) {
      this.displayAccountChoice = false;
      console.log(cardClicked);

      if (cardClicked === "PP_One_Site") {
        this.loginType = "site";
        this.badgeString = "PayPoint One Site";
      } else if (cardClicked === "PP_Mini_Site") {
        this.loginType = "sitePayPointMini";
        this.loginButtonString = "PPMini Log in";
        this.badgeString = "PayPoint Mini Site";
      }

      // this.loginButtonString = `Log in`;
    },
  },
};
</script>

<style lang="scss">
.spinner-border {
  width: 9rem;
  height: 9rem;
}
</style>

<style lang="scss" scoped>
@import "Design/_variables.scss";
.form-group {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.form-group-errors {
  padding-top: 10px;
  display: flex;
  flex-direction: column;
}
.form-control {
  width: 80%;
}
.form-control:focus {
  border-color: $color-brand-yellow;
  box-shadow: none;
}
.form-label {
  width: 20%;
}
.badged-inputbox {
  position: relative;
  width: 80%;
}
.badged-inputbox input {
  width: 100%;
}
@media only screen and (max-width: 1200px) {
  .badged-inputbox {
    width: 80%;
  }
  .form-label {
    width: 20%;
    align-self: unset;
  }
  .form-control {
    width: 80%;
  }
}
//for mobile
@media only screen and (max-width: 768px) {
  .badged-inputbox {
    width: 100%;
  }
  .form-label {
    width: 100%;
    align-self: flex-start;
  }
  .form-group {
    display: flex;
    flex-direction: column;
  }
  .form-control {
    width: 100%;
  }
}
</style>

<style lang="scss" scoped>
@import "Design/_variables.scss";
@import "Design/paypoint-styles.scss";
@import "Design/paypoint-form-common-styles.scss";

.paypoint-link {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 12px;
  margin-right: 27px;
  align-items: center;
}

#click-to-register {
  padding-top: 20px;
}
#coloured-subnote {
  vertical-align: super;
  color: red;
}

.overlayed-badge {
  position: absolute;
  right: 3%;
  top: 25%;
  text-align: center;
  padding: 5px 10px;
}
.login-button {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.bottom-section {
  width: 100%;
  display: flex;
  justify-content: flex-end;
}
</style>

<style lang="scss" scoped>
// the animation for the badge
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  50% {
    transform: scale(1.5);
  }
  100% {
    transform: scale(1);
  }
}
</style>

<style lang="scss" scoped>
// animation for the dissapearing/re-appearing form elements
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.5s ease;
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(40px);
  opacity: 0;
}
.spinner-grow {
  width: 1rem;
  height: 1rem;
}
.badge {
  width: 155px;
}
</style>
